/**
 * This will watch a element for viewport intersection
 * @example ng-more-less="_ml_plm"
 */

const ngMoreLess = [() => {
    return {
        scope: { model: '=ngMoreLess'},
        link: ( $scope, $item, $params ) => {

            // let computed = window.getComputedStyle($item[0]);
            // let lineHeight = computed.getPropertyValue('line-height');

            if ( $item[0].parentNode.clientHeight < $item[0].clientHeight ) {
                $scope.model = false;
            }
        }
    }
}];

export default ngMoreLess;

